import { DraggedItem } from "Components/DropArea/types/DraggedItem";
import { ScheduleEntry } from "domain-entities";
import { useDrag } from "react-dnd";

export interface CalendarEntry {
	id: string;
	startTime: number;
	endTime: number;
	userId?: string;
	resourceId?: string;
	typeId?: string;
	projectId?: string;
}

export const MINUTE_GAP = 30;
export const TABLE_CELL_MARGIN_Y = 4;
export const CALENDAR_ENTRY_HEIGHT = 32;
export const CALENDAR_ENTRY_TYPE_HEIGHT = 22;

export function getScheduleEntryTypeIds(scheduleEntries: ScheduleEntry[]) {
	return scheduleEntries
		.reduce<string[]>((result, scheduleEntry) => {
			if (scheduleEntry.typeId && !result.includes(scheduleEntry.typeId)) {
				result.push(scheduleEntry.typeId);
			}

			return result;
		}, [])
		.sort((a, b) => a.localeCompare(b));
}

export function getCalendarEntryViewKey(
	calendarEntry: CalendarEntry,
	isSingleRow?: boolean
) {
	return [
		calendarEntry.id,
		calendarEntry.startTime,
		calendarEntry.endTime,
		calendarEntry.projectId,
		calendarEntry.resourceId,
		calendarEntry.typeId,
		calendarEntry.userId,
		isSingleRow,
	].join("-");
}

export function useDraggedItem(
	type: string,
	calendarEntry: CalendarEntry,
	colorHex: string,
	isAddingNew?: boolean
) {
	const draggedItem: DraggedItem = {
		type,
		calendarEntry,
		colorHex,
		isAddingNew: !!isAddingNew,
	};

	const [{ isDragging }, drag, preview] = useDrag({
		item: draggedItem,
		options: {
			dropEffect: "move",
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});

	return {
		isDragging,
		drag,
		preview,
	};
}
